import React from "react";
import { WEBVIEW_RESOURCE_VERSION } from 'common/cacheOverwrite';

type Proc = {
    langCode : string;
    cardProductCode : string;
}

const CardProductBenefitHTML : React.FC<Proc> = ({langCode , cardProductCode}) => {
    return (
        <div id="wrap">
            <div id="container" className="pcHidden">
                <section className="contents">
                    <div className="inner">
                        <div className="section serverWrap">
                            <iframe className="productApplyDetail" key={cardProductCode} 
                                src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/benefit/${cardProductCode}/apply/card_apply_benefit.html?v=${WEBVIEW_RESOURCE_VERSION}&lang=${langCode}`}
                                allowFullScreen={true} title='benefit'/>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default CardProductBenefitHTML;